import { render } from "./ProjectTitle.vue?vue&type=template&id=7325132c&scoped=true"
import script from "./ProjectTitle.vue?vue&type=script&lang=js"
export * from "./ProjectTitle.vue?vue&type=script&lang=js"

import "./ProjectTitle.vue?vue&type=style&index=0&id=7325132c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7325132c"]])

export default __exports__